module.exports = __webpack_public_path__ + "img/lists.846c46d0.svg";